<script>
import Layout from "../../layouts/main";
import PlaneApi from "@/services/plane-api";
import appConfig from "@/app.config";


export default {
  name: 'Request-estimate',
  page: {
    title: "Demande de Devis",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout},
  data() {
    return {
        planeList: []
     
    };
  },
  mounted() {
    this.findAllPlane();
  },

  computed:{
    getPlaneTitle(){
        return this.planeList.map(plane => plane.title).join(", ");
    }
    
  },

  methods:{

    getColor(title) {
      switch (title) {
        case "IRON":
          return "#137437"; // Dark, cool gray to represent iron
        case "BRONZE":
          return "#137437"; // Warm, reddish-brown to represent bronze
        case "SILVER":
          return "#137437"; // Slightly darker metallic silver for better distinction
        case "PALLADIUM":
          return "#137437"; // Light bluish-gray for palladium
        case "GOLD":
          return "#137437"; // Classic bright yellow-gold for gold
        case "PLATINUM":
          return "#137437"; //"#A6A6A6"; // Rich, dark metallic gray for platinum (more prominent)
        default:
          return "#000"; // Default color (white) for unknown metals
      }
    },



    findAllPlane(){
        PlaneApi.findAllPlane().then(result=>{
            if(result){
                this.planeList = result
            }
        })
    }
  }

  
};
</script>

<template>
  <Layout>

    <div class="bg-light text-center pt-md-5 pb-md-5 pt-0 pb-0">
      <div>
        <div class="pt-0  pr-3 pl-3">
          <h1 class="pt-5 text-dark text-wrap font-weight-bold" style="font-size:2.5rem;">
            {{ $t('planeProposal.title') }}
          </h1>
        </div>

        <hr class="separator-line mt-3 mb-3">

        <div class="mt-5">
          <h6 class="header-60-width mx-auto text-dark font-size-16 text-wrap text-justify text-md-center" style="letter-spacing: 0.08em; line-height: 1.8;">
            {{ $t('planeProposal.subTitle1') }}
            <strong> ({{ getPlaneTitle }})</strong>
            {{ $t('planeProposal.subTitle2') }}
          </h6>
        </div>
      </div>
    </div>


    <div class="bg-light pr-md-0 pl-md-0 pr-3 pl-3">
      <div class="home-page-80-width">
          <div v-if="this.planeList" class=" row mb-4 pr-2 pl-2">
                  <div v-for="plane in planeList" :key="plane.title" class=" col-lg-4 col-md-6 col-sm-12 mt-3 pt-4 mb-4 p-lg-2 p-0" >

                    <div v-if="plane.title != 'PERSONNALISE'" class="col-4 mx-auto" style="box-shadow: rgb(133, 127, 127) 1px 8px 17px; max-width: 400px; border: radius 0px;"
                        :style="{ borderTop: '5px solid ' + getColor(plane.title) }">      

                        <b-card header-class="bg-white border-primary " class="mx-auto" style="max-width: 400px; " >
                    
                          
                          <!-- <template v-slot:header >
                            <div class="row mt-3 mb-0"  >
                              <div class="col col-12">
                                <h3 class="my-0 font-weight-bold" :style="{ color: getColor(plane.title) }"  style="font-weight:900; font-size:24px">{{ plane.title }}</h3>
                              </div>
                            </div>
                          </template> -->
                        
                          <div class="row mb-0"  >
                              <div class="col col-12">
                                <h3 class="my-0 font-weight-bold" :style="{ color: getColor(plane.title) }"  style="font-weight:900; font-size:24px">{{ plane.title }}</h3>
                              </div>
                            </div>

                            <div class="row"  >
                              <div class="col-12">
                                <h2 class="text-uppercase text-left" :style="{ color: getColor(plane.title) }" style="font-size:35px;" >{{plane.quantityBags}}</h2>
                              </div>
                            </div> 

                            <div class="row mt-4 ml-2" style="height: 100px;">
                              <div class="col-12">
                                    <div class="row">
                                        <div class="col-12">
                                        <!-- <img  alt="check-double"  width="20px" class="mr-2"  src="@/assets/icons/check-double.svg" style="cursor: pointer;"  /> -->
                                        <span class="font-size-14"><i>{{ $t('planeProposal.option1') }} <strong> {{ plane.zones }}</strong></i></span>
                                      </div>
                                      <div class="col-12 mt-2">
                                        <!-- <img  alt="check-double"  width="20px" class="mr-2"  src="@/assets/icons/check-double.svg" style="cursor: pointer;"  /> -->
                                        <span class="font-size-14"><i>{{ $t('planeProposal.option2') }} <strong>{{ plane.quantityPartner }} {{ $t('planeProposal.unityOption2') }} </strong></i></span>
                                      </div>
                                      <div class="col-12 mt-2">
                                        <!-- <img  alt="check-double"  width="20px" class="mr-2"  src="@/assets/icons/check-double.svg" style="cursor: pointer;"  /> -->
                                        <span class="font-size-14"><i>{{ $t('planeProposal.option3') }} <strong>{{ plane.views }} </strong></i></span>
                                      </div>
                                      <!-- <div class="col-12 mt-2">
                                        <img  alt="check-double"  width="20px" class="mr-2"  src="@/assets/icons/check-double.svg" style="cursor: pointer;"  />
                                        <span class="font-size-14"><i>{{ $t('planeProposal.option4') }} <strong>{{ $t('planeProposal.sectors') }} </strong></i></span>
                                      </div> -->
                                    </div>
                              </div>

                            </div>  

                            <div class="row mt-4">
                              <div class="col-12">
                                <router-link :to="{ path: '/demande/devis/' + plane.title.toLowerCase() }">
                                  <b-button variant="light" class="w-100 text-white" :style="{ backgroundColor: getColor(plane.title) }" >
                                    <strong class="font-size-16  text-uppercase" style="letter-spacing:2px;">{{ $t('planeProposal.button') }}</strong>
                                  </b-button>
                                </router-link>
                              </div>
                            </div> 

                  </b-card>
                </div>



                </div>
          </div>
      </div>
    </div>

    <div class="row header pb-5">
      <div class="col-12">
        <div class="text-center pt-5 pb-5">
          <h1 class="text-white text-wrap font-weight-bold" style="font-size:2rem;">
            {{ $t('planeProposal.personnaliserRequest') }}
          </h1>
        </div>
      </div>

      <div class="col-12 text-center mb-3">
        <router-link :to="{ path: '/demande/devis/PERSONNALISE' }">
                      <b-button variant="warning"  style="padding: 10px 26px; letter-spacing:3px;" class="font-weight-bold font-size-18 m-md-0 m-2">
                        <div class="font-weight-normal d-none d-md-block font-size-12 mb-1">{{ $t('planeProposal.personnaliserRequestlabel') }}</div>
                        <span class="d-none d-md-inline">{{ $t('planeProposal.Request') }} </span>{{ $t('planeProposal.personnaliserRequestButton') }}
                      </b-button>
                    </router-link>
      </div>

    </div>
    


  </Layout>
</template>



<style scoped>


.header {
  background:  linear-gradient(19deg,rgba(55, 152, 91, 1) 0%,rgba(19, 116, 55, 1) , rgba(23, 83, 45, 1) 100%)!important;
  text-align: center;
}

.header-60-width,
.sub-title-60-width {
  max-width: 80%;
  margin: auto;
}

@media (min-width: 768px) {
  .header-60-width,
  .sub-title-60-width {
      max-width: 60%;
  }
}
.separator-line {
  width: 15%;
  height: 4px;
  background-color: #137437 ;
  border: none;
  margin: auto;
}

.sub-title-60-width {
  margin: 30px auto 0;
  color: #f7d584;
}

.responsive-iframe {
  height: 450px;
}

@media (min-width: 768px) {
  .responsive-iframe {
      height: 650px;
  }
}





</style>
